<template>
    <div>
        <div class="h-screen">
            <PageHeader
                :is-primary-menu-open="isPrimaryMenuOpen"
                @show-user-dropdown-menu-changed="showUserDropdownMenuChanged"
            />
            <div class="pt-[64px] md:pt-[92px] h-full">
                <slot />
            </div>
        </div>
        <Modal />
        <div
            v-if="isPrimaryMenuOpen || isUserDropdownMenuOpen || showModal"
            class="overlay z-30"
            :class="{ 'z-50': showModal }"
        />
    </div>
</template>

<script setup lang="ts">
    import PageHeader from '~/components/pageHeader/PageHeader.vue';
    import Modal from '~/components/modal/TheModal.vue';
    import { useMenuStore } from '~/stores/menu';
    import { storeToRefs } from 'pinia';
    import { useModalStore } from '~/stores/modalStore';

    const { showModal } = storeToRefs(useModalStore());
    const menuStore = useMenuStore();
    const { showUserDropdownMenuChanged } = menuStore;
    const { isPrimaryMenuOpen, isUserDropdownMenuOpen } = storeToRefs(menuStore);
</script>

<style lang="scss" scoped>
  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    backdrop-filter: blur(2px);
  }
</style>
